import React from 'react';

import './main-title.css';

class MainTitle extends React.Component{
  render(){
    const btSearch = this.props.onSearch ? (
      <a href='#' className='bt-search' onClick={this.props.onSearch}>
      <i className="fas fa-search"></i>
      <span>Buscar</span>
      </a>) : null;
    return(
      <div className="main-title">
        <h1>{this.props.title}</h1>
        {btSearch}
      </div>
    );
  }
}

export default MainTitle;



// WEBPACK FOOTER //
// ./src/components/page/main-title/MainTitle.js